import { render, staticRenderFns } from "./driver-item.vue?vue&type=template&id=532ca496&scoped=true&"
import script from "./driver-item.vue?vue&type=script&lang=js&"
export * from "./driver-item.vue?vue&type=script&lang=js&"
import style0 from "./driver-item.vue?vue&type=style&index=0&id=532ca496&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532ca496",
  null
  
)

export default component.exports